import React from 'react';
import { Header } from 'carbon-components-react/lib/components/UIShell';

import UIShellHeader from './UIShellHeader';
import UIShellSiderRight from './UIShellSiderRight';

const UIShell = () => {
  return (
    <Header aria-label="Circa">
      <UIShellHeader />

      <UIShellSiderRight />
    </Header>
  );
};

export default UIShell;
